import { h, render } from 'preact';

import { onLmpTabChange } from '../../../utils/aem-utils';
import { preactMultipleWidgets } from '../../utils';

import { TextToSpeechComponent } from './component';
import widget from './widget-config';

const renderWidget = () => {
  const widgets = preactMultipleWidgets(widget);
  widgets.forEach(({ $root, props }) => {
    render(<TextToSpeechComponent htmlProps={props.htmlProps} widget={widget} $root={$root} />, $root);
  });
};

export const hydrate = () => {
  renderWidget();

  onLmpTabChange(() => {
    document.dispatchEvent(new CustomEvent('tts-pause'));
    setTimeout(renderWidget, 500);
  });
};
